export default {
  isModalVisible: false,
  linkingStatusCode: null,
  isRequestLoading: false,
  hasErrorLinking: false,
  successLinking: false,
  apiErrors: {
    emailCode: null,
    passwordCode: null,
    globalCode: null
  }
}
